export default __webpack_public_path__ + "static/media/icon__4.4e8327a7.svg";